/**
 * A version of Object.assign that does a deep copy as opposed to a shallow copy
 * Its pretty basic! But seems to do the trick :)
 *
 * @param copy - the object to copy values to
 */
export function deepCopy<T>(copy: T): T {
  let target = null;

  if (ArrayBuffer.isView(copy)) {
    // eslint-disable-next-line
    return new (copy as any).constructor(copy);
  } else if (Array.isArray(copy)) {
    target = [];
  } else if (typeof copy === 'object') {
    target = {};
  } else {
    return copy;
  }

  deepCopyChildren(copy, target as T);

  return target as T;
}

export function deepCopyChildren<T>(copy: T, target: T): void {
  for (const i in copy) {
    const valueToCopy = copy[i];

    if (ArrayBuffer.isView(valueToCopy)) {
      target[i] = new (valueToCopy as any).constructor(valueToCopy);
    } else if (Array.isArray(valueToCopy)) {
      target[i] = [] as unknown as T[Extract<keyof T, string>];

      deepCopyChildren(valueToCopy, target[i]);
    } else if (typeof valueToCopy === 'object') {
      target[i] = {} as unknown as T[Extract<keyof T, string>];

      deepCopyChildren(valueToCopy, target[i]);
    } else {
      target[i] = valueToCopy;
    }
  }
}
